import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../components/Auth.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const VerifyEmailPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    verifyEmail();
  }, [token]);

  const verifyEmail = async () => {
    try {
      const response = await fetch(`${API_URL}/auth/verify-email/${token}`);
      const data = await response.json();

      if (response.ok) {
        setStatus('success');
        setMessage('Email verified successfully! Redirecting to login...');
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } else {
        setStatus('error');
        setMessage(data.error || 'Verification failed');
      }
    } catch (err) {
      setStatus('error');
      setMessage('Network error. Please try again.');
    }
  };

  return (
    <div className="auth-page">
      <div className="cosmic-bg"></div>
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <h1 className="auth-title">🔮 Email Verification</h1>
          </div>

          {status === 'verifying' && (
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <div className="spinner" style={{ margin: '0 auto 1rem' }}></div>
              <p style={{ color: 'var(--textSecondary)' }}>Verifying your email...</p>
            </div>
          )}

          {status === 'success' && (
            <div className="success-message">
              <span className="success-icon">✓</span>
              {message}
            </div>
          )}

          {status === 'error' && (
            <div>
              <div className="error-message">
                <span className="error-icon">⚠️</span>
                {message}
              </div>
              <button 
                className="auth-submit-btn" 
                style={{ marginTop: '2rem' }}
                onClick={() => navigate('/login')}
              >
                Go to Login
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailPage;
